import React, { useCallback } from "react";
import Dropzone from "react-dropzone";
import {
  RiCheckboxCircleLine,
  RiCloseCircleLine,
  RiDragDropLine,
} from "react-icons/ri";

import { DropContainer, UploadMessage } from "./styles";

interface IUploadProps {
  onUpload: Function;
}

const Upload: React.FC<IUploadProps> = ({ onUpload }) => {
  const renderDragMessage = useCallback(
    (isDragActive: boolean, isDragReject: boolean) => {
      if (!isDragActive) {
        return (
          <UploadMessage>
            <RiDragDropLine />
            Clique ou arraste as Notas Fiscais aqui
          </UploadMessage>
        );
      }

      if (isDragReject) {
        return (
          <UploadMessage type="error">
            <RiCloseCircleLine />
            Formato de arquivo não suportado
          </UploadMessage>
        );
      }
      return (
        <UploadMessage type="success">
          <RiCheckboxCircleLine />
          Solte os arquivos aqui
        </UploadMessage>
      );
    },
    [],
  );

  return (
    <Dropzone
      accept={{ "text/xml": ["text/xml"] }}
      onDropAccepted={files => onUpload(files)}
    >
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <DropContainer
          {...getRootProps()}
          isDragActive={isDragActive}
          isDragReject={isDragReject}
        >
          <input {...getInputProps()} />
          {renderDragMessage(isDragActive, isDragReject)}
        </DropContainer>
      )}
    </Dropzone>
  );
};

export default Upload;
